module.exports = __webpack_public_path__ + "static/scale-model-of-the-wright-cycle-company-complex-in-dayton-ohio-27bf5fff4676b86ef399ad8384bc74d5.png";